<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import type { ClassValue } from "svelte/elements";
	import { SubscriptionKind } from "@core/schema/SubscriptionKind.js";
	import { Cart } from "../cart/Cart.svelte.js";
	import translations from "./GiftSubscriptionButton.translations.json" with { type: "json" };
	import Button from "./common/Button.svelte";
	import { ButtonSize } from "./common/ButtonSize.js";
	import type { ButtonVariant } from "./common/ButtonVariant.js";
	import Formatted from "./common/Formatted.svelte";

	const translate = getTranslate(translations);

	const { variant, class: customClass }: { variant: ButtonVariant; class?: ClassValue } = $props();
</script>

<Button
	onclick={(): void => {
		Cart.openSubscriptionConfigurator(SubscriptionKind.Gift);
	}}
	size={ButtonSize.Medium}
	class={["pointer-events-auto", customClass]}
	{variant}
>
	<Formatted text={translate("giftSubscription")} />
</Button>
